/**
 * @desc 库容审批-确认
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: Array<number>,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/personal/material/confirm',
    data,
  });
}

export function mock(data: Array<number>): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/personal/material/confirm',
    data,
  });
}
